<!-- Page banner Area -->
<div class="page-banner bg-3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content">
                    <h2>Forgot password</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Forgot password</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Start Sign in Area -->
<div class="sign-in-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8">
                <div class="text-center mb-4">
                    <div class="fs-3 text-black fw-semibold mb-2">Forgot password?</div>
                    <p class="text-muted mb-0">Fill the form to reset your password</p>
                </div>

                <div class="card auth-card">
                    <div class="card-body p-4 p-md-5">
                        <form [formGroup]="forgotPasswordForm">
                            <div class="mb-4">
                                <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                                <input type="email" class="form-control" id="email" placeholder="Enter your Email"
                                    formControlName="email" name="email">
                                <div class="text-danger small mt-2" *ngIf="forgotPasswordForm.controls['email'].invalid &&
                                    (forgotPasswordForm.controls['email'].dirty ||
                                        forgotPasswordForm.controls['email'].touched || isSubmit)
                                ">
                                    <span *ngIf="forgotPasswordForm.controls['email'].errors.required">
                                        Please enter your email address!
                                    </span>
                                    <span *ngIf="forgotPasswordForm.controls['email'].errors.email">
                                        Please enter your email address!
                                    </span>
                                </div>
                            </div>

                            <div class="text-center mb-4">
                                <button type="button" class="btn btn-blink" (click)="sendResetLink()">
                                    <span>Send reset link</span>
                                    <i class="bi bi-arrow-right"></i>
                                </button>
                            </div>

                            <p class="text-center text-muted mb-0">
                                Return to <a routerLink="/sign-in" class="text-decoration-none fw-semibold">Sign In</a>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Sign in  Area -->
